export default __webpack_public_path__ + "static/media/banner-mobile-bg-orange-template.8f0bc968.svg";